import { ElementRef } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KeycloakService } from 'keycloak-angular';
import { AppService } from './app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'ops-portal';
  favIcon: HTMLLinkElement = document.querySelector('#favIcon');

  constructor(
    private translate: TranslateService,
    private keycloakService: KeycloakService,
    private appService: AppService,
  ) {
    translate.setDefaultLang('es');
    translate.use('es');
  }

  async ngOnInit() {
    document.documentElement.style.setProperty(`--color-primary`, this.appService.settings.css.colors["primary"]);
    document.documentElement.style.setProperty(`--color-primary-light`, this.appService.settings.css.colors["primary-light"]);
    document.documentElement.style.setProperty(`--color-primary-dark`, this.appService.settings.css.colors["primary-dark"]);
    document.documentElement.style.setProperty(`--color-accent`, this.appService.settings.css.colors["accent"]);
    document.documentElement.style.setProperty(`--color-warn`, this.appService.settings.css.colors["warn"]);
    this.favIcon.href = 'assets/' + this.appService.settings.css.favicon;
    const token = await this.keycloakService.getToken();
    //localStorage.setItem('token', 'EXAMPLE');
    localStorage.setItem('token', token);
  }
}
